export default __webpack_public_path__ + "static/media/book.d15d120e.png";